export default {
  CHOICES: {
    ja: {
      answers: [
        {
          id: 1,
          pt: 1,
          name: "そう思う"
        },
        {
          id: 2,
          pt: 2,
          name: "ややそう思う"
        },
        {
          id: 3,
          pt: 3,
          name: "どちらともいえない"
        },
        {
          id: 4,
          pt: 4,
          name: "ややそう思わない"
        },
        {
          id: 5,
          pt: 5,
          name: "そう思わない"
        }
      ]
    },
    en: {
      answers: [
        {
          id: 1,
          pt: 1,
          name: "Agree"
        },
        {
          id: 2,
          pt: 2,
          name: "Slightly agree"
        },
        {
          id: 3,
          pt: 3,
          name: "Neither agree nor disagree"
        },
        {
          id: 4,
          pt: 4,
          name: "Slightly disagree"
        },
        {
          id: 5,
          pt: 5,
          name: "Disagree"
        }
      ]
    },
    zh: {
      answers: [
        {
          id: 1,
          pt: 1,
          name: "同意"
        },
        {
          id: 2,
          pt: 2,
          name: "稍微同意"
        },
        {
          id: 3,
          pt: 3,
          name: "既 不同意也不反对"
        },
        {
          id: 4,
          pt: 4,
          name: "稍微不同意"
        },
        {
          id: 5,
          pt: 5,
          name: "不同意"
        }
      ]
    },
    vi: {
      answers: [
        {
          id: 1,
          pt: 1,
          name: "Hoàn toàn đồng ý"
        },
        {
          id: 2,
          pt: 2,
          name: "Đồng ý"
        },
        {
          id: 3,
          pt: 3,
          name: "Không có ý kiến"
        },
        {
          id: 4,
          pt: 4,
          name: "Hơi không đồng ý"
        },
        {
          id: 5,
          pt: 5,
          name: "Hoàn toàn không đồng ý"
        }
      ]
    }
  },
  QUESTIONS: {
    ja: [
      {
        id: 1,
        title: "理念共感",
        content: "当社の理念・ビジョンに共感している"
      },
      {
        id: 2,
        title: "経営目標明示",
        content: "当社の経営目標とその実現方法は、社員に明示されている"
      },
      {
        id: 3,
        title: "将来性",
        content: "当社には将来性がある"
      },
      {
        id: 4,
        title: "経営トップ層への信頼",
        content: "経営トップ層は、社員から信頼されている"
      },
      {
        id: 5,
        title: "経営トップ層の傾聴",
        content: "経営トップ層は、社員の声に耳を傾けている"
      },
      {
        id: 6,
        title: "自組織で働く誇り",
        content: "当社で働いていることに誇りを持っている"
      },
      {
        id: 7,
        title: "商品・ｻｰﾋﾞｽへの愛着",
        content: "当社が提供している商品・サービスが好きだ"
      },
      {
        id: 8,
        title: "雰囲気との相性",
        content: "当社の雰囲気は、自分に合っている"
      },
      {
        id: 9,
        title: "労働時間管理",
        content: "当社は、社員が過剰な労働時間とならないよう管理している"
      },
      {
        id: 10,
        title: "休憩・休日管理",
        content: "当社は、社員が休憩時間や休日を確保できるよう管理している"
      },
      {
        id: 11,
        title: "有給休暇取得",
        content: "有給休暇は取得しやすく、十分消化している"
      },
      {
        id: 12,
        title: "各種休暇制度",
        content:
          "出産休暇や育児休暇、介護休暇など、各種休暇制度が整備され、取得されている"
      },
      {
        id: 13,
        title: "福利厚生制度",
        content:
          "社員の生活を充実させるような福利厚生の制度や施設が十分に整っている"
      },
      {
        id: 14,
        title: "人事評価制度",
        content: "人事評価のしくみに納得している"
      },
      {
        id: 15,
        title: "昇進・昇格制度",
        content: "昇進・昇格のしくみに納得している"
      },
      {
        id: 16,
        title: "適材適所の配置",
        content: "当社では、社員の能力や適性に応じた人員配置を行っている"
      },
      {
        id: 17,
        title: "能力開発による登用機会",
        content:
          "当社では、知識や技術を高めたり資格を取得することによって、専門性の高いポジションにつく機会が用意されている"
      },
      {
        id: 18,
        title: "給与制度",
        content: "給与や賞与の決定のしくみに納得している"
      },
      {
        id: 19,
        title: "給与水準（仕事）",
        content: "自分の給与は、仕事内容に照らして適切な水準である"
      },
      {
        id: 20,
        title: "給与水準（同業他社）",
        content: "自分の給与は、同じ業種の違う会社と同等以上の水準である"
      },
      {
        id: 21,
        title: "上司の職場方向性明示",
        content: "現在の上司は、職場の方向性についてメンバーに説明している"
      },
      {
        id: 22,
        title: "上司の目標明示",
        content: "現在の上司は、職場の目標を明確に示している"
      },
      {
        id: 23,
        title: "上司の役割分担明示",
        content: "現在の上司は、メンバー同士の役割分担を明確にしている"
      },
      {
        id: 24,
        title: "上司の仕事配分",
        content:
          "現在の上司は、メンバーの知識、技術、経験を考慮して仕事の配分をしている"
      },
      {
        id: 25,
        title: "マニュアル整備",
        content: "職場には、実態に即した仕事のマニュアルが整備されている"
      },
      {
        id: 26,
        title: "上司の業務支援",
        content:
          "現在の上司は、職場の目標達成のために、メンバーの仕事を効果的に支援している"
      },
      {
        id: 27,
        title: "上司の能力開発支援",
        content: "現在の上司は、メンバーに対して能力開発のアドバイスをしている"
      },
      {
        id: 28,
        title: "上司の就業配慮",
        content: "現在の上司は、メンバーのおかれている状況や心情に配慮している"
      },
      {
        id: 29,
        title: "上司の傾聴",
        content: "現在の上司は、メンバーの意見に十分に耳を傾けている"
      },
      {
        id: 30,
        title: "上司の公正評価",
        content: "現在の上司は、メンバーの評価を公正に行なっている"
      },
      {
        id: 31,
        title: "上司との信頼関係",
        content: "現在の上司は、信頼できる存在である"
      },
      {
        id: 32,
        title: "同僚とのノウハウ共有",
        content: "職場の同僚とは、知識や情報を共有している"
      },
      {
        id: 33,
        title: "同僚との協働関係",
        content: "職場の同僚とは、互いに助け合って仕事を進めている"
      },
      {
        id: 34,
        title: "同僚との意見交換",
        content: "職場の同僚とは、自由で活発に意見交換をしている"
      },
      {
        id: 35,
        title: "同僚との信頼関係",
        content: "職場の同僚とは、お互いに信頼しあっている"
      },
      {
        id: 36,
        title: "同僚との人間関係",
        content: "職場の同僚との人間関係は良好である"
      },
      {
        id: 37,
        title: "関連部署との情報共有",
        content: "必要な情報は関連部署と十分に共有されている"
      },
      {
        id: 38,
        title: "関連部署への相互支援",
        content: "職場では、関連部署に対する支援が惜しみなく行われている"
      },
      {
        id: 39,
        title: "関連部署間の連携",
        content: "部署間の仕事上の連携はスムーズである"
      },
      {
        id: 40,
        title: "職場の環境衛生",
        content: "職場は、清潔で衛生的である"
      },
      {
        id: 41,
        title: "職場の整理整頓",
        content: "職場は、整理整頓されている"
      },
      {
        id: 42,
        title: "職場のスペース",
        content: "職場には、効率的に仕事が行えるスペースが確保されている"
      },
      {
        id: 43,
        title: "仕事での能力発揮",
        content: "現在の仕事の中で、自分の能力を十分に発揮している"
      },
      {
        id: 44,
        title: "仕事の効率化・改善",
        content: "現在の仕事をより効率的に行うための改善を行っている"
      },
      {
        id: 45,
        title: "仕事のやりがい",
        content: "現在の仕事にやりがいを感じている"
      },
      {
        id: 46,
        title: "仕事の達成感",
        content: "現在の仕事の中で、達成感を感じている"
      },
      {
        id: 47,
        title: "仕事への愛着",
        content: "現在の仕事が好きだ"
      },
      {
        id: 48,
        title: "仕事への誇り",
        content: "現在の仕事に誇りを持っている"
      },
      {
        id: 49,
        title: "職場人員充足",
        content: "業務量に対して、職場の人員数は十分足りている"
      },
      {
        id: 50,
        title: "業務負荷軽減策",
        content: "社員の業務負荷を軽減するような対策がとられている"
      },
      {
        id: 51,
        title: "過度な残業",
        content: "度を超した残業を強いられることはない"
      },
      {
        id: 52,
        title: "仕事の責任範囲",
        content: "現在の仕事の責任範囲は適切である（大きすぎない）"
      },
      {
        id: 53,
        title: "仕事のプレッシャー",
        content: "仕事上で、過度なプレッシャーに悩まされることはない"
      },
      {
        id: 54,
        title: "疲労感",
        content: "仕事上で、精神的・肉体的な疲労を強く感じることはない"
      },
      {
        id: 55,
        title: "顧客志向",
        content: "お客さまの要望に応えられるよう、全力で努力している"
      },
      {
        id: 56,
        title: "顧客貢献の実感",
        content: "現在の仕事を通じて、お客さまの役に立っている"
      },
      {
        id: 57,
        title: "顧客満足の実感",
        content: "現在の仕事が、お客さまの満足につながっているという実感がある"
      },
      {
        id: 58,
        title: "顧客意見・要望の共有・活用",
        content:
          "お客さまからのご意見・ご要望についての情報は、組織内で共有され、現場で活用されている"
      },
      {
        id: 59,
        title: "教育・研修機会",
        content:
          "仕事上で必要な知識や技術については、十分な教育や研修の機会が与えられている"
      },
      {
        id: 60,
        title: "仕事へのチャレンジ機会",
        content: "自分の成長につながる仕事にチャレンジする機会がある"
      },
      {
        id: 61,
        title: "成長の実感",
        content: "現在の仕事の中で、自分が成長しているという実感がある"
      },
      {
        id: 62,
        title: "キャリア展望",
        content: "自分がやりたい将来の仕事は、現在の仕事の延長線上にある"
      },
      {
        id: 63,
        title: "総合満足度",
        content: "当社に対して、総合的に満足している"
      }
    ],
    en: [
      {
        id: 1,
        title: "理念共感",
        content:
          "I am sympathetic to the vision and guiding principles of our company."
      },
      {
        id: 2,
        title: "経営目標明示",
        content:
          "The management objectives of the company and its way of implementing are expressed to employees."
      },
      {
        id: 3,
        title: "将来性",
        content: "There is a potential for our company in the near future."
      },
      {
        id: 4,
        title: "経営層への信頼",
        content: "Top management are trusted by employees."
      },
      {
        id: 5,
        title: "経営層・社員の声傾聴",
        content:
          "Top management have been listening to the voice of employees sincerely."
      },
      {
        id: 6,
        title: "働く誇り",
        content: "I am proud of working with this company."
      },
      {
        id: 7,
        title: "商品・ｻｰﾋﾞｽへの愛着",
        content: "I like the products and/or services of our company."
      },
      {
        id: 8,
        title: "当社雰囲気合う",
        content: "The atmosphere of the company is right and suitable for me."
      },
      {
        id: 9,
        title: "時間管理",
        content:
          "The company have managed so that the working hours will not be excessive."
      },
      {
        id: 10,
        title: "休日・休暇確保",
        content:
          "The company have provided employees with enough break time and holiday."
      },
      {
        id: 11,
        title: "有給取得",
        content: "It is easy to take paid leave and it has been fully utilized."
      },
      {
        id: 12,
        title: "各種休暇整備",
        content:
          "Various holiday systems such as parental leave, maternity leave and care leave, are institutionalized and many have taken them."
      },
      {
        id: 13,
        title: "福利厚生制度",
        content:
          "The facility and system for the welfare are achieved sufficiently and enrich the lives of the employees."
      },
      {
        id: 14,
        title: "人事評価",
        content:
          "I am satisfied with personnel evaluation following the company’s MBOs."
      },
      {
        id: 15,
        title: "昇進・昇給",
        content: "I am satisfied with the mechanism of promotion and pay hike."
      },
      {
        id: 16,
        title: "適材適所",
        content:
          "The staffing of our company is in accordance with the competencies and aptitude of the employees properly."
      },
      {
        id: 17,
        title: "能力・専門性登用機会",
        content:
          "By obtaining the qualification or enhancing the high level of knowledge and skills, opportunity for the highly specialized positions are available in my company."
      },
      {
        id: 18,
        title: "給与・賞与の決定",
        content:
          "I am satisfied with the mechanism of determination of my salaries and bonuses."
      },
      {
        id: 19,
        title: "給与水準（仕事）",
        content:
          "My salary is appropriate level in the aspect of the job description."
      },
      {
        id: 20,
        title: "給与水準（同業他社）",
        content:
          "My salary is equal or more compared to the other companies of the same industry."
      },
      {
        id: 21,
        title: "上司・方向性明示",
        content:
          "My boss describes and explains the direction of the business unit to the employees."
      },
      {
        id: 22,
        title: "上司・目標明示",
        content: "My boss clearly shows the goal of the business unit."
      },
      {
        id: 23,
        title: "上司・役割分担明示",
        content:
          "My boss makes it clear about the division of the roles between members."
      },
      {
        id: 24,
        title: "上司・仕事配分",
        content:
          "My boss allocates jobs by taking into account of the knowledge, technology and experiences of the individual members."
      },
      {
        id: 25,
        title: "マニュアル整備",
        content:
          "In the workplace, documentation of work process is in place and ready in line with the actual workplace situations."
      },
      {
        id: 26,
        title: "メンバー支援",
        content:
          "To achieve the goals of the business unit, my boss effectively supports the members."
      },
      {
        id: 27,
        title: "能力開発アドバイス",
        content:
          "My boss provides advice for human development and takes care of the members."
      },
      {
        id: 28,
        title: "状況、心情配慮",
        content:
          "My boss pays attention to the feelings and situations of the member."
      },
      {
        id: 29,
        title: "意見傾聴",
        content: "My boss is listening well to the voices of the member."
      },
      {
        id: 30,
        title: "評価公正",
        content:
          "My boss makes a fair evaluation of the member about their jobs."
      },
      {
        id: 31,
        title: "上司への信頼",
        content: "My boss is trustworthy."
      },
      {
        id: 32,
        title: "知識・情報共有",
        content: "I share the information and knowledge with my co-workers."
      },
      {
        id: 33,
        title: "助け合い",
        content:
          "I work and help each other in the workplace with my co-workers."
      },
      {
        id: 34,
        title: "意見交換",
        content: "I exchange opinions actively and freely with my co-workers."
      },
      {
        id: 35,
        title: "信頼",
        content: "The co-workers and I have trusted each other."
      },
      {
        id: 36,
        title: "人間関係",
        content: "The relationship with my co-workers at workplace is good."
      },
      {
        id: 37,
        title: "情報共有",
        content:
          "The necessary information is shared well with the relevant departments."
      },
      {
        id: 38,
        title: "関連部署への支援",
        content:
          "In the workplace, support for the relevant departments is provided enormously."
      },
      {
        id: 39,
        title: "連携円滑",
        content:
          "The coordination of work between departments is smooth and appropriate."
      },
      {
        id: 40,
        title: "清潔さ",
        content: "The workplace is clean and sanitary."
      },
      {
        id: 41,
        title: "整理整頓",
        content: "The workplace is uncluttered, neat and organized."
      },
      {
        id: 42,
        title: "作業スペース",
        content: "In the workplace, space for the effective working is ensured."
      },
      {
        id: 43,
        title: "能力発揮",
        content: "I give full play to the skills in my current job."
      },
      {
        id: 44,
        title: "業務改善",
        content: "I make improvements for better and more efficient job."
      },
      {
        id: 45,
        title: "仕事のやりがい",
        content: "My current job is rewarding."
      },
      {
        id: 46,
        title: "達成感",
        content: "I feel a great sense of accomplishment in my current job."
      },
      {
        id: 47,
        title: "仕事愛着",
        content: "I like doing my current job."
      },
      {
        id: 48,
        title: "仕事への誇り",
        content: "I am proud of doing my current job."
      },
      {
        id: 49,
        title: "要員過不足",
        content:
          "Compared to business volume, the number of employees is enough and sufficient."
      },
      {
        id: 50,
        title: "業務負荷軽減",
        content:
          "Measures to reduce the workload have been taken for the employees."
      },
      {
        id: 51,
        title: "過度な残業",
        content: "I have never been forced to do overtime working too far."
      },
      {
        id: 52,
        title: "職責",
        content:
          "The range of my job responsibility is appropriate (not too large)."
      },
      {
        id: 53,
        title: "仕事のプレッシャー",
        content: "I do not suffer from excessive pressure with the job."
      },
      {
        id: 54,
        title: "精神・肉体の疲労",
        content: "I never feel the mental and physical fatigue with the job."
      },
      {
        id: 55,
        title: "要望への努力",
        content:
          "To meet the needs of our customers, I strive with all my force."
      },
      {
        id: 56,
        title: "役立ち",
        content: "I am helpful to customers through the current job."
      },
      {
        id: 57,
        title: "満足の実感",
        content:
          "There is a feeling that my current job leads to customer satisfaction."
      },
      {
        id: 58,
        title: "ニーズの共有・活用",
        content:
          "The opinions and requests from customers are shared within the company and have been utilized at the front line."
      },
      {
        id: 59,
        title: "教育・研修機会",
        content:
          "As to the knowledge and skills required for the job, training opportunities and adequate educational programs are given."
      },
      {
        id: 60,
        title: "仕事へのチャレンジ",
        content:
          "I have an opportunity to challenge the job that leads to the growth of myself."
      },
      {
        id: 61,
        title: "成長実感",
        content: "There is a feeling that I am growing through my current job."
      },
      {
        id: 62,
        title: "将来仕事",
        content:
          "The job which I really mean to do in the future is the extension of my current job"
      },
      {
        id: 63,
        title: "総合的な満足",
        content: "I am happy with the company as a whole."
      }
    ],
    zh: [
      {
        id: 1,
        title: "理念共感",
        content: "我赞同我们公司的理念和愿景。"
      },
      {
        id: 2,
        title: "経営目標明示",
        content: "公司管理目标和其贯彻方式傳达至员工。"
      },
      {
        id: 3,
        title: "将来性",
        content: "我们公司在不久的将来有更好发展的潜能。"
      },
      {
        id: 4,
        title: "経営層への信頼",
        content: "高层管理获得员工的信任。"
      },
      {
        id: 5,
        title: "経営層・社員の声傾聴",
        content: "高层管理人员真诚倾听员工的心声。"
      },
      {
        id: 6,
        title: "働く誇り",
        content: "我在这家公司工作而感到自豪。"
      },
      {
        id: 7,
        title: "商品・ｻｰﾋﾞｽへの愛着",
        content: "我很喜欢我们公司的产品和/或服务。"
      },
      {
        id: 8,
        title: "当社雰囲気合う",
        content: "公司的气氛积极，适合我。"
      },
      {
        id: 9,
        title: "時間管理",
        content: "公司管理得当，工作时间不过度。"
      },
      {
        id: 10,
        title: "休日・休暇確保",
        content: "公司妥善管理，让员工有足够的休息时间和假期。"
      },
      {
        id: 11,
        title: "有給取得",
        content: "很容易申请有薪休假，并得以充分利用。"
      },
      {
        id: 12,
        title: "各種休暇整備",
        content: "各种假期，如育儿假，产假和护理假，已制度化得以员工的使用。"
      },
      {
        id: 13,
        title: "福利厚生制度",
        content: "公司的福利设施及系统得到充分实现，丰富员工的生活。"
      },
      {
        id: 14,
        title: "人事評価",
        content: "我很满意公司人才评价机制。"
      },
      {
        id: 15,
        title: "昇進・昇給",
        content: "我很满意公司升职和加薪的机制。"
      },
      {
        id: 16,
        title: "適材適所",
        content: "我们公司的工作人员是根据员工的能力和性向选定。"
      },
      {
        id: 17,
        title: "能力・専門性登用機会",
        content:
          "通过获得更高教育学历或加强知识和技能，可在我公司有提高专业化位置的机会。"
      },
      {
        id: 18,
        title: "給与・賞与の決定",
        content: "我很满意公司决定工资和奖金的机制。"
      },
      {
        id: 19,
        title: "給与水準（仕事）",
        content: "我的工资和工作相匹配。 "
      },
      {
        id: 20,
        title: "給与水準（同業他社）",
        content: "相比同行业的其他公司我的工资等于或更高。"
      },
      {
        id: 21,
        title: "上司・方向性明示",
        content: "我的老板向员工描述和解释业务单位的方向和作业。"
      },
      {
        id: 22,
        title: "上司・目標明示",
        content: "我的老板清楚表明了业务单位的目标。"
      },
      {
        id: 23,
        title: "上司・役割分担明示",
        content: "我的老板清楚地解释了成员之间的角色及分工。"
      },
      {
        id: 24,
        title: "上司・仕事配分",
        content: "我的老板分配工作时考虑到员工的知识，技术和各个成员的经验。"
      },
      {
        id: 25,
        title: "マニュアル整備",
        content: "在工作场所，工作流程的文件到位，并与实际工作情况一致。"
      },
      {
        id: 26,
        title: "メンバー支援",
        content: "为了实现业务单位的目标，我的老板有效支持其成员。"
      },
      {
        id: 27,
        title: "能力開発アドバイス",
        content: "我的老板提供人力发展的建议，并照顾成员。"
      },
      {
        id: 28,
        title: "状況、心情配慮",
        content: "我的老板重视成员的感受和情况。"
      },
      {
        id: 29,
        title: "意見傾聴",
        content: "我的老板倾听成员的心声和反馈。"
      },
      {
        id: 30,
        title: "評価公正",
        content: "我的老板以公正的方式评价成员的工作。"
      },
      {
        id: 31,
        title: "上司への信頼",
        content: "我的老板是值得信赖的。"
      },
      {
        id: 32,
        title: "知識・情報共有",
        content: "我与我的同事共享信息和知识。"
      },
      {
        id: 33,
        title: "助け合い",
        content: "在工作场所我和同事一起工作，互相帮忙。"
      },
      {
        id: 34,
        title: "意見交換",
        content: "我与同事积极和自由地交换意见。"
      },
      {
        id: 35,
        title: "信頼",
        content: "同事和我相互信任。"
      },
      {
        id: 36,
        title: "人間関係",
        content: "在工作场所和我的同事的关系良好。"
      },
      {
        id: 37,
        title: "情報共有",
        content: "必要的信息与相关部门共享。"
      },
      {
        id: 38,
        title: "関連部署への支援",
        content: "在职场中，为相关部门提供的支持是全面完整的。"
      },
      {
        id: 39,
        title: "連携円滑",
        content: "工作部门之间的协调是平顺和适当的。"
      },
      {
        id: 40,
        title: "清潔さ",
        content: "工作场所干净及卫生。"
      },
      {
        id: 41,
        title: "整理整頓",
        content: "工作场所整斉，整洁及有序。"
      },
      {
        id: 42,
        title: "作業スペース",
        content: "在工作地方，提供了有效工作空间。"
      },
      {
        id: 43,
        title: "能力発揮",
        content: "我充分发挥在我目前的工作技能。"
      },
      {
        id: 44,
        title: "業務改善",
        content: "我做出改善以达到更高的工作效率。"
      },
      {
        id: 45,
        title: "仕事のやりがい",
        content: "我现在的工作是有价值的。"
      },
      {
        id: 46,
        title: "達成感",
        content: "我觉得我现在的工作很有成就感。"
      },
      {
        id: 47,
        title: "仕事愛着",
        content: "我喜欢做我现在的工作。"
      },
      {
        id: 48,
        title: "仕事への誇り",
        content: "我对我目前的工作感到自豪。"
      },
      {
        id: 49,
        title: "要員過不足",
        content: "相比业务量，现有雇员的数量是足够的。"
      },
      {
        id: 50,
        title: "業務負荷軽減",
        content: "措施以减少员工工作量已实行了。"
      },
      {
        id: 51,
        title: "過度な残業",
        content: "我从来没有被迫加班工作。"
      },
      {
        id: 52,
        title: "職責",
        content: "我的工作职责范围是适当的（不是太大）。"
      },
      {
        id: 53,
        title: "仕事のプレッシャー",
        content: "我不会因过大的压力与就业受到影响。"
      },
      {
        id: 54,
        title: "精神・肉体の疲労",
        content: "我从来不觉得因工作感觉精神和身体的疲劳。"
      },
      {
        id: 55,
        title: "要望への努力",
        content: "为满足广大客户的需求，我会努力尽我所能。"
      },
      {
        id: 56,
        title: "役立ち",
        content: "我现在的工作对客户是有帮助的."
      },
      {
        id: 57,
        title: "満足の実感",
        content: "感觉我目前的工作会导致和提高客户满意度。"
      },
      {
        id: 58,
        title: "ニーズの共有・活用",
        content: "来自客户的意见和要求会在公司内部共享并适当的运用于前线。"
      },
      {
        id: 59,
        title: "教育・研修機会",
        content:
          "工作所需的知识和技能，公司提供足够培训机会及教育计划的一部分。"
      },
      {
        id: 60,
        title: "仕事へのチャレンジ",
        content: "我有机会去挑战工作，导致更好的个人成长。"
      },
      {
        id: 61,
        title: "成長実感",
        content: "感觉我通过现在的工作一起成长。"
      },
      {
        id: 62,
        title: "将来仕事",
        content: "我真正想要做的未来工作是我目前工作的延伸。"
      },
      {
        id: 63,
        title: "総合的な満足",
        content: "我满意现在工作的公司。"
      }
    ],
    vi: [
      {
        id: 1,
        title: "理念共感",
        content: "Hiểu triết lý và tầm nhìn của Công ty"
      },
      {
        id: 2,
        title: "経営目標明示",
        content:
          "Các mục tiêu kinh doanh của Công ty và phương pháp thực hiện được trình bày rõ ràng với nhân viên"
      },
      {
        id: 3,
        title: "将来性",
        content: "Công ty có tương lai tiềm năng"
      },
      {
        id: 4,
        title: "経営層への信頼",
        content: "Tầng lớp lãnh đạo của Công ty được nhân viên tin cậy"
      },
      {
        id: 5,
        title: "経営層・社員の声傾聴",
        content:
          "Tầng lớp lãnh đạo của Công ty biết lắng nghe tiếng nói của nhân viên"
      },
      {
        id: 6,
        title: "働く誇り",
        content: "Cảm thấy tự hào khi được làm việc ở Công ty"
      },
      {
        id: 7,
        title: "商品・ｻｰﾋﾞｽへの愛着",
        content: "Thích sản phẩm và dịch vụ mà Công ty cung cấp"
      },
      {
        id: 8,
        title: "当社雰囲気合う",
        content: "Cảm thấy bầu không khí của Công ty phù hợp với bản thân"
      },
      {
        id: 9,
        title: "時間管理",
        content:
          "Công ty có chế độ quản lý để nhân viên không phải làm việc quá thời gian"
      },
      {
        id: 10,
        title: "休日・休暇確保",
        content:
          " Công ty có chế độ quản lý để đảm bảo nhân viên có thời gian nghỉ ngơi vào ngày nghỉ"
      },
      {
        id: 11,
        title: "有給取得",
        content: "Có thể dễ dàng xin nghỉ phép có lương và lấy phép đầy đủ"
      },
      {
        id: 12,
        title: "各種休暇整備",
        content:
          "Công nhân viên được hưởng đầy đủ các loại chế độ nghỉ phép như nghỉ thai sản, nghỉ nuôi con nhỏ, nghỉ để chăm sóc người thân"
      },
      {
        id: 13,
        title: "福利厚生制度",
        content:
          "Công ty chuẩn bị đầy đủ cơ sở vật chất và có chế độ phúc lợi để hỗ trợ cuộc sống của công nhân viên"
      },
      {
        id: 14,
        title: "人事評価",
        content: "Hài lòng với cơ chế đánh giá nhân sự"
      },
      {
        id: 15,
        title: "昇進・昇給",
        content: "Hài lòng với cơ chế thăng chức, thăng bậc"
      },
      {
        id: 16,
        title: "適材適所",
        content:
          "Công nhân viên được bố trí công việc phù hợp với năng lực và khả năng của bản thân"
      },
      {
        id: 17,
        title: "能力・専門性登用機会",
        content:
          "Có cơ hội đạt được vị trí với tính chuyên môn cao trong Công ty bằng việc nâng cao kiến thức và kỹ thuật hay lấy chứng chỉ"
      },
      {
        id: 18,
        title: "給与・賞与の決定",
        content: "Hài lòng với cơ chế tính tiền lương và tiền thưởng"
      },
      {
        id: 19,
        title: "給与水準（仕事）",
        content:
          "Tiền lương của bản thân được trả tương xứng với tính chất công việc thực hiện"
      },
      {
        id: 20,
        title: "給与水準（同業他社）",
        content:
          "Tiền lương của bản thân ở mức bằng hoặc cao hơn so với các công ty khác cùng ngành"
      },
      {
        id: 21,
        title: "上司・方向性明示",
        content:
          "Công nhân viên được cấp trên mô tả và giải thích về phương hướng hoạt động của bộ phận làm việc"
      },
      {
        id: 22,
        title: "上司・目標明示",
        content: "Cấp trên hiện nay đã có chỉ rõ mục tiêu của bộ phận làm việc"
      },
      {
        id: 23,
        title: "上司・役割分担明示",
        content:
          "Cấp trên hiện nay phân công rõ ràng vai trò của các thành viên"
      },
      {
        id: 24,
        title: "上司・仕事配分",
        content:
          "Cấp trên hiện nay có xem xét kiến thức, kỹ năng, kinh nghiệm của thành viên khi giao việc"
      },
      {
        id: 25,
        title: "マニュアル整備",
        content:
          "Nơi làm việc được trang bị tài liệu hướng dẫn công việc phù hợp với tình hình thực tế"
      },
      {
        id: 26,
        title: "メンバー支援",
        content:
          "Cấp trên hiện nay đã hỗ trợ hiệu quả công việc của các thành viên nhằm đạt được mục tiêu của bộ phận"
      },
      {
        id: 27,
        title: "能力開発アドバイス",
        content:
          "Cấp trên hiện nay có hướng dẫn, tư vấn về phát triển năng lực cho các thành viên"
      },
      {
        id: 28,
        title: "状況、心情配慮",
        content:
          "Cấp trên hiện nay có suy xét đến tình trạng và cảm xúc của các thành viên"
      },
      {
        id: 29,
        title: "意見傾聴",
        content:
          "Cấp trên hiện nay tích cực lắng nghe ý kiến của các thành viên"
      },
      {
        id: 30,
        title: "評価公正",
        content:
          "Cấp trên hiện nay đánh giá việc thực hiện công việc của công nhân viên một cách công minh"
      },
      {
        id: 31,
        title: "上司への信頼",
        content: "Cấp trên hiện nay là đáng tin cậy"
      },
      {
        id: 32,
        title: "知識・情報共有",
        content:
          "Bạn đã và đang chia sẻ thông tin và kiến thức với các đồng nghiệp"
      },
      {
        id: 33,
        title: "助け合い",
        content:
          "Bạn và các đồng nghiệp tương trợ giúp đỡ lẫn nhau trong công việc"
      },
      {
        id: 34,
        title: "意見交換",
        content:
          "Bạn có trao đổi ý kiến một cách tích cực và tự do với các đồng nghiệp"
      },
      {
        id: 35,
        title: "信頼",
        content: "Bạn và các đồng nghiệp tin tưởng lẫn nhau"
      },
      {
        id: 36,
        title: "人間関係",
        content: "Bạn có mối quan hệ tốt đẹp với các đồng nghiệp"
      },
      {
        id: 37,
        title: "情報共有",
        content:
          "Các thông tin cần thiết được chia sẻ một cách đầy đủ với các bộ phận phòng ban liên quan"
      },
      {
        id: 38,
        title: "関連部署への支援",
        content:
          "Tại nơi làm việc, việc hỗ trợ cho các bộ phận phòng ban liên quan đang được tiến hành tích cực"
      },
      {
        id: 39,
        title: "連携円滑",
        content:
          "Sự liên kết trong công việc giữa các bộ phận phòng ban diễn ra một cách nhịp nhàng"
      },
      {
        id: 40,
        title: "清潔さ",
        content: "Nơi làm việc sạch sẽ và vệ sinh"
      },
      {
        id: 41,
        title: "整理整頓",
        content: "Nơi làm việc được sắp xếp gọn gàng ngăn nắp"
      },
      {
        id: 42,
        title: "作業スペース",
        content:
          "Nơi làm việc có đủ không gian làm việc để có thể làm việc hiệu quả"
      },
      {
        id: 43,
        title: "能力発揮",
        content:
          "Bạn đã và đang phát huy đầy đủ khả năng của mình trong công việc hiện tại"
      },
      {
        id: 44,
        title: "業務改善",
        content:
          "Bạn đã và đang thực hiện những cải tiến để làm cho công việc hiệu quả hơn"
      },
      {
        id: 45,
        title: "仕事のやりがい",
        content: "Bạn cảm thấy công việc hiện tại là có ý nghĩa, đáng làm"
      },
      {
        id: 46,
        title: "達成感",
        content:
          "Bạn có cảm giác hoàn thành, cảm giác toại nguyện trong công việc hiện tại"
      },
      {
        id: 47,
        title: "仕事愛着",
        content: "Bạn thấy thích công việc hiện tại"
      },
      {
        id: 48,
        title: "仕事への誇り",
        content: "Bạn tự hào về công việc hiện tại"
      },
      {
        id: 49,
        title: "要員過不足",
        content:
          "Số lượng nhân công tại nơi làm việc là đủ so với khối lượng công việc"
      },
      {
        id: 50,
        title: "業務負荷軽減",
        content:
          "Các biện pháp để giảm tải công việc của nhân viên đã và đang được thực thi"
      },
      {
        id: 51,
        title: "過度な残業",
        content: "Không có chuyện bị buộc phải làm thêm giờ quá mức"
      },
      {
        id: 52,
        title: "職責",
        content:
          "Phạm vi trách nhiệm công việc hiện tại là phù hợp (không quá lớn)"
      },
      {
        id: 53,
        title: "仕事のプレッシャー",
        content: "Không bị áp lực quá mức trong công việc"
      },
      {
        id: 54,
        title: "精神・肉体の疲労",
        content:
          "Không cảm thấy sự mệt mỏi nặng nề về tinh thần và thể chất trong công việc"
      },
      {
        id: 55,
        title: "要望への努力",
        content:
          "Bạn đang nỗ lực hết mình để có thể đáp ứng nhu cầu của khách hàng "
      },
      {
        id: 56,
        title: "役立ち",
        content: "Bạn giúp ích cho khách hàng thông qua công việc hiện tại"
      },
      {
        id: 57,
        title: "満足の実感",
        content:
          "Bạn có thể cảm nhận được rằng công việc hiện tại dẫn đến sự hài lòng của khách hàng"
      },
      {
        id: 58,
        title: "ニーズの共有・活用",
        content:
          "Các ý kiến và phản hồi của khách hàng được chia sẻ trong nội bộ cơ quan và được sử dụng để cải tiến công việc thực tế."
      },
      {
        id: 59,
        title: "教育・研修機会",
        content:
          "Bạn có cơ hội được đào tạo các kỹ năng và kiến thức cần thiết để thực hiện công việc"
      },
      {
        id: 60,
        title: "仕事へのチャレンジ",
        content:
          "Bạn có cơ hội để thử những công việc dẫn đến sự trưởng thành của bản thân"
      },
      {
        id: 61,
        title: "成長実感",
        content:
          "Có thể cảm thấy sự trưởng thành của bản thân trong công việc hiện tại"
      },
      {
        id: 62,
        title: "将来仕事",
        content:
          "Công việc hiện tại là nền tảng cho công việc bạn muốn làm trong tương lai"
      },
      {
        id: 63,
        title: "総合的な満足",
        content: "Về tổng thể, tôi hài lòng với Công ty"
      }
    ]
  },
  SENTENSE: {
    ja: {
      freeCommentTitle:
        "その他、ご意見・ご感想などありましたら、ご自由にご記入ください。",
      completeTitle: "ご回答ありがとうございました。"
    },
    en: {
      freeCommentTitle:
        "If you have any further comments, please feel free to share in the below.",
      completeTitle: "Thank you very much for your cooperation."
    },
    zh: {
      freeCommentTitle: "请写下您的意见和想法",
      completeTitle: "谢谢您的合作"
    },
    vi: {
      freeCommentTitle:
        "Vui lòng viết rõ thêm các ý kiến hoặc đề xuất của bạn tại đây",
      completeTitle: "Cảm ơn bạn đã trả lời"
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/data/QuestionData.js